<template>
  <div>
    <div class="bet-qs">
      <div class="bet-1">
        <BigComponent
          class="item-bet-1"
          :is-highlight-result="isHighlightResult"
          :name="name"
          :table="table"
          :round="round"
          :score="score"
          :data="data"
          :rate="odds.BIG"
          :current-chip="currentChip"
          :game-state="gameState"
        />
        <FlipResult
          class="item-bet-2"
          :table="table"
          :game-state="gameState"
          :score="score"
          :window-focus="windowFocus"
        />
        <SmallComponent
          class="item-bet-3"
          :is-highlight-result="isHighlightResult"
          :name="name"
          :table="table"
          :round="round"
          :score="score"
          :data="data"
          :rate="odds.SMALL"
          :current-chip="currentChip"
          :game-state="gameState"
        />
      </div>
      <div class="bet-2">
        <OneComponent
          class="item-bet-4"
          :is-highlight-result="isHighlightResult"
          :name="name"
          :table="table"
          :round="round"
          :score="score"
          :data="data"
          :rate="odds.NUM_1"
          :current-chip="currentChip"
          :game-state="gameState"
        />
        <TwoComponent
          class="item-bet-5"
          :is-highlight-result="isHighlightResult"
          :name="name"
          :table="table"
          :round="round"
          :score="score"
          :data="data"
          :rate="odds.NUM_2"
          :current-chip="currentChip"
          :game-state="gameState"
        />
        <ThreeComponent
          class="item-bet-6"
          :is-highlight-result="isHighlightResult"
          :name="name"
          :table="table"
          :round="round"
          :score="score"
          :data="data"
          :rate="odds.NUM_3"
          :current-chip="currentChip"
          :game-state="gameState"
        />
        <FourComponent
          class="item-bet-7"
          :is-highlight-result="isHighlightResult"
          :name="name"
          :table="table"
          :round="round"
          :score="score"
          :data="data"
          :rate="odds.NUM_4"
          :current-chip="currentChip"
          :game-state="gameState"
        />
        <FiveComponent
          class="item-bet-8"
          :is-highlight-result="isHighlightResult"
          :name="name"
          :table="table"
          :round="round"
          :score="score"
          :data="data"
          :rate="odds.NUM_5"
          :current-chip="currentChip"
          :game-state="gameState"
        />
        <SixComponent
          class="item-bet-9"
          :is-highlight-result="isHighlightResult"
          :name="name"
          :table="table"
          :round="round"
          :score="score"
          :data="data"
          :rate="odds.NUM_6"
          :current-chip="currentChip"
          :game-state="gameState"
        />
      </div>
    </div>
    <div class="img-bet-qs" :class="css" ></div>
    <div class="bet-success" :class="{ active: isSucceed === true }"><span>Thành công</span></div>
  </div>
</template>

<script>
import BigComponent from '@components/taixiu/buttons/big.vue';
import SmallComponent from '@components/taixiu/buttons/small.vue';
import OneComponent from '@components/taixiu/buttons/one.vue';
import TwoComponent from '@components/taixiu/buttons/two.vue';
import ThreeComponent from '@components/taixiu/buttons/three.vue';
import FourComponent from '@components/taixiu/buttons/four.vue';
import FiveComponent from '@components/taixiu/buttons/five.vue';
import SixComponent from '@components/taixiu/buttons/six.vue';
import FlipResult from "@components/taixiu/flip-result.vue";
import { GAMESTATE } from '@config/constants.js';

export default {
  components: {
    BigComponent,
    SmallComponent,
    OneComponent,
    TwoComponent,
    ThreeComponent,
    FourComponent,
    // eslint-disable-next-line vue/no-unused-components
    FiveComponent,
    // eslint-disable-next-line vue/no-unused-components
    SixComponent,
    FlipResult
  },
  props: {
    name: { type: String, default: "" },
    table: { type: String, default: "" },
    round: { type: Number, default: 0 },
    score: { type: Object, default: () => ({})},
    data: { type: Object, default: () => ({})},
    odds: { type: Object, default: () => ({})},
    isHighlightResult: Boolean,
    currentChip: { type: Number, default: 0 },
    gameState: {
      type: String,
      default: GAMESTATE.WAITING_NEW_GAME,
    },
    windowFocus: { type: Number, default: 0 },
  },
  data() {
    return {
      isSucceed: false,
      css: "",
    }
  },
  watch: { 
    '$i18n.locale': function(newVal, oldVal) {
      if(newVal !== 'vn') {
        this.css = `img-bet-qs-${newVal}`;
      } else {
        this.css = "";
      }
    }
  }
}
</script>

<style>

</style>
